import React, { useEffect, useState } from "react";
import { Stack, Button, Divider } from "@mui/material";

type HierarchyValue = "handlerFirst" | "productFirst";

interface Props {
  initialValue?: HierarchyValue; // ערך התחלתי בלבד
  onChange: (newValue: HierarchyValue) => void;
  storageKey?: string;
}

const HierarchyToggle: React.FC<Props> = ({ initialValue, onChange, storageKey }) => {
  const getInitialValue = (): HierarchyValue => {
    const stored = storageKey ? localStorage.getItem(storageKey) : null;
    if (stored === "handlerFirst" || stored === "productFirst") return stored;
    if (initialValue === "handlerFirst" || initialValue === "productFirst") return initialValue;
    return "handlerFirst";
  };

  const [currentValue, setCurrentValue] = useState<HierarchyValue>(getInitialValue);

  useEffect(() => {
    onChange(currentValue);
  }, [currentValue, onChange]);

 const handleClick = (newValue: HierarchyValue) => {

  setCurrentValue(newValue);
  if (storageKey) localStorage.setItem(storageKey, newValue);
};

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Button
        variant={currentValue === "handlerFirst" ? "contained" : "outlined"}
        onClick={() => handleClick("handlerFirst")}
      >
        → יצרן
      </Button>
      <Divider orientation="vertical" flexItem />
      <Button
        variant={currentValue === "productFirst" ? "contained" : "outlined"}
        onClick={() => handleClick("productFirst")}
      >
        מוצר →
      </Button>
    </Stack>
  );
};

export default HierarchyToggle;
